import { render } from "./ventas.vue?vue&type=template&id=20db05e4&scoped=true&ts=true"
import script from "./ventas.vue?vue&type=script&lang=ts"
export * from "./ventas.vue?vue&type=script&lang=ts"

import "./ventas.vue?vue&type=style&index=0&id=20db05e4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20db05e4"]])

export default __exports__